import sup from "../images/soup.svg";
import antipast from "../images/antipasto.svg";
import beer from "../images/beer.svg";
import calzone from "../images/calzone.svg";
import pasta from "../images/pasta.svg";
import rizoto from "../images/risotto.svg";
import salad from "../images/salad.svg";
import steak from "../images/steak.svg";
import pizza from "../images/pizza.svg";
import embelsira from "../images/panna-cotta.svg";

export const kategorite = [
  {
    id: 1,
    alb: "Supa",
    ita: "Zuppe",
    eng: "Soups",
    img: sup,
    linkAlb: "/supa",
    linkIta: "/zuppe",
    linkEng: "/soups",
  },
  {
    id: 2,
    alb: "Sallatë",
    ita: "Insalate",
    eng: "Salad",
    img: salad,
    linkAlb: "/sallata",
    linkIta: "/insalate",
    linkEng: "/salads",
  },
  {
    id: 3,
    alb: "Antipasta",
    ita: "Antipasti",
    eng: "Appetizers",
    img: antipast,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 4,
    alb: "Pizza",
    ita: "Pizza",
    eng: "Pizza",
    img: pizza,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  // {
  //     id: 5,
  //     alb: "Baguette",
  //     ita: "Baguette",
  //     eng: "Baguette",
  //     img: calzone,
  //     linkAlb: '/baguette',
  //     linkIta: '/baguette-ita',
  //     linkEng: '/baguette-eng'
  // },
  {
    id: 6,
    alb: "Calzone",
    ita: "Calzone",
    eng: "Calzone",
    img: calzone,
    linkAlb: '/calzone',
    linkIta: '/calzone-ita',
    linkEng: '/calzone-eng'
  },
  {
    id: 7,
    alb: "Conchas",
    ita: "Conchas",
    eng: "Conchas",
    img: calzone,
    linkAlb: "/conchas",
    linkIta: "/conchas-ita",
    linkEng: "/conchas-eng",
  },
  {
    id: 8,
    alb: "Pasta",
    ita: "Pasta",
    eng: "Pasta",
    img: pasta,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 9,
    alb: "Rizoto",
    ita: "Rissoto",
    eng: "Rissoto",
    img: rizoto,
    linkAlb: "/risoto",
    linkIta: "/rissoto",
    linkEng: "/rissoto-eng",
  },
  {
    id: 11,
    alb: "Pjata Kryesore",
    ita: "Secondi Piatti",
    eng: "Main Dishes",
    img: steak,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 12,
    alb: "Ekstra",
    ita: "Aggiuntivo",
    eng: "Additional",
    img: embelsira,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 13,
    alb: "Pijet",
    ita: "Bevande",
    eng: "Drinks",
    img: beer,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
];
